// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DIC_F","rootNoMargin":"styles_rootNoMargin__3-0Ye"};